var Businesses;
(function (Businesses) {
    Businesses.LOGIN_BUSINESSES = [
        // COM-2208 リリースされたものだけ表示されるように
        { code: 'UMOBILE_D', name: 'U-mobile' },
        { code: 'UMOBILE_EA', name: 'U-mobile*E' },
        { code: 'HIKARI_01', name: 'U-NEXT光01' },
        { code: 'HIKARI_COLLABO', name: 'U-NEXT光' },
        { code: 'UMOBILE_SONET', name: 'U-mobileLTE' },
        { code: 'WITHUNET', name: 'withUnet' },
        { code: 'UMOBILE_PREMIUM', name: 'U-mobilePremium' }
    ];
})(Businesses || (Businesses = {}));
export default Businesses;
